import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getSearchPropertyDetail } from "../../actions/customer/searchAction";

type SearchResult = {
  total_count?: number;
  total_page?: number;
  current_page?: number;
  list?: any[];
  appliedBounds?: boolean;
} | null;

export interface ISearchState {
  loading: boolean;
  searchResult: SearchResult;
  error: any;
}

const initialState: ISearchState = {
  loading: false,
  searchResult: null,
  error: null,
};

const searchSlice = createSlice({
  name: "customer-search",
  initialState,
  reducers: {
    updateLikeState: (
      state,
      { payload }: { payload: { updateId: string; isSaved: boolean } }
    ) => {
      const { updateId, isSaved } = payload;

      state.searchResult = {
        ...state.searchResult,
        list: state.searchResult?.list?.map((item: any) =>
          item._id === updateId ? { ...item, is_saved: isSaved } : item
        ),
      };
    },
    updateBoundStatus: (
      state,
      { payload }: { payload: { appliedBounds: boolean } }
    ) => {
      state.searchResult = {
        ...state.searchResult,
        appliedBounds: payload?.appliedBounds,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSearchPropertyDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSearchPropertyDetail.fulfilled, (state, { payload }) => {
        state.loading = false;
        // state.searchResult = payload?.data;
        state.searchResult = {
          ...payload?.data,
          appliedBounds: payload?.appliedBounds ?? false,
        };

        const html = document.documentElement;

        // Restore the scroll position
        const scrollTop = Math.abs(parseInt(html.style.top || "0", 10));
        html.style.removeProperty("--st");
        html.classList.remove("noscroll");
        html.style.removeProperty("top");

        // Restore the actual scroll position
        window.scrollTo(0, scrollTop);
      })
      .addCase(
        getSearchPropertyDetail.rejected,
        (state, action: PayloadAction<any>) => {
          state.loading = false;
          state.searchResult = null;
          state.error = action.payload;
        }
      );
  },
});

export const { updateLikeState, updateBoundStatus } = searchSlice.actions;
export default searchSlice.reducer;
